import { Customer } from "@main/customers/models/Customer";
import { Order } from "@beeldit/ecommerce/orders/models/Order";

export class SuperOrder {
  public static PENDING_STATUS = 1;
  public static PAYED_STATUS = 2;
  public static COMPLETED = 3;
  public static CANCELLED = 4;

  public id: number;
  public reference: string;
  public status: number;
  public lower_order_status: number;
  public customer_id: number;
  public customer: Customer;
  public billing_address: any;
  public shipping_address: any;
  public total_prices: any;
  public orders: Order[];
  public observations: string;
  public request_invoice: number;
  public created_at: string;
  public updated_at: string;
  public deleted_at: string;
  public payment: any;

  constructor() {
    this.id = 0;
    this.reference = "";
    this.status = 1; // Pending
    this.lower_order_status = 1;
    this.customer_id = 0;
    this.customer = new Customer();
    this.billing_address = {};
    this.shipping_address = {};
    this.total_prices = {};
    this.orders = [];
    this.observations = "";
    this.request_invoice = 0;
    this.created_at = "";
    this.updated_at = "";
    this.deleted_at = "";
    this.payment = {};
  }
}
